
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/tnf-live",
      function () {
        return require("private-next-pages/events/tnf-live.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/tnf-live"])
      });
    }
  